import { axios } from '@argon/app/axios'
import { toFilterString, stampItem } from '@argon/app/helpers'

const NAMESPACE = 'users'

const state = {
  users: [],
  tableItemsCount: null,
  tablePagination: {}
}

const mutations = {
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_TABLE_PAGINATION: (state, payload) => {
    state.tablePagination = payload
  },
  SET_TABLE_ITEMS: (state, payload) => {
    state.tableItems = payload
  },
  SET_TABLE_ITEMS_COUNT: (state, payload) => {
    state.tableItemsCount = payload
  }
}
const actions = {
  listUsers: ({ commit, rootState }, { pager }) => {
    let pagerParams = pager || state.tablePagination
    const filters = toFilterString(rootState.app.appliedFilters[NAMESPACE])
    let params = { include: 'account', filters, ...pagerParams }
    return new Promise((resolve, reject) => {
      axios({
        url: '/users',
        method: 'GET',
        params
      })
        .then(({ data }) => {
          commit('SET_USERS', data.items)
          commit('SET_TABLE_ITEMS_COUNT', data.count)
          commit('SET_TABLE_PAGINATION', pagerParams)
          resolve(data.items)
        })
        .catch(reject)
    })
  },
  createUser: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/users',
        data: payload,
        method: 'POST'
      })
        .then(({ data }) => {
          return dispatch('listUsers')
        })
        .catch(reject)
    })
  },
  getUser: ({}, userId) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/users/${userId}`,
        method: 'GET'
      })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(reject)
    })
  },
  patchUser: ({ dispatch }, payload) => {
    const { data, userId } = payload
    return new Promise((resolve, reject) => {
      return axios({
        url: `/users/${userId}`,
        data,
        method: 'PATCH'
      })
        .then(() => {
          return dispatch('listUsers')
        })
        .catch(reject)
    })
  },
  getAccount: ({}, userId) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/accounts/${userId}`,
        method: 'GET'
      })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(reject)
    })
  },
  patchAccount: ({}, payload) => {
    const { data, userId } = payload
    return new Promise((resolve, reject) => {
      axios({
        url: `/accounts/${userId}`,
        data,
        method: 'PATCH'
      })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(reject)
    })
  },
  deleteUser: ({ dispatch }, { userId, pager, filters }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/users/${userId}`,
        method: 'DELETE'
      })
        .then(() => {
          return dispatch('listUsers', { pager, filters })
        })
        .catch(reject)
    })
  },
  clearUsers: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_USERS', [])
      resolve(true)
    })
  },
  clearCurrentUser: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_USER', {})
      resolve(true)
    })
  }
}
const getters = {
  users: (state) => state.users,
  currentUser: (state) => state.currentUser
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export { NAMESPACE }
